module.exports = __webpack_public_path__ + "img/proyecto_4.64b15bcb.png";